import React from 'react';
import { Helmet } from 'react-helmet-async';
import {
    SITE_NAME,
    DEFAULT_DESCRIPTION,
    OG_IMAGE,
    buildCanonical,
} from '../../config/seo';

const Seo = ({
    title,
    description = DEFAULT_DESCRIPTION,
    canonicalPath,
    image = OG_IMAGE,
    type = 'website',
    noindex = false,
    keywords,
}) => {
    const canonical = buildCanonical(canonicalPath);
    const robots = noindex ? 'noindex, nofollow' : 'index, follow';

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            {keywords && <meta name="keywords" content={keywords} />}
            <meta name="robots" content={robots} />
            <link rel="canonical" href={canonical} />

            <meta property="og:type" content={type} />
            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={canonical} />
            <meta property="og:locale" content="ru_RU" />
            {image && <meta property="og:image" content={image} />}

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            {image && <meta name="twitter:image" content={image} />}
        </Helmet>
    );
};

export default Seo;
